import { useState, type FormEvent } from 'react';

const FORM_URL = 'https://readdy.ai/api/form/dahgn0roh653ivfvnuog';

export default function NewsletterForm() {
  const [status, setStatus] = useState<'idle' | 'submitting' | 'success' | 'error'>('idle');
  const [formError, setFormError] = useState('');

  const handleSubmit = async (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    const formEl = event.currentTarget;
    const payload = new FormData(formEl);

    const guard = String(payload.get('website_alt') || '').trim();
    if (guard) {
      setStatus('success');
      setFormError('');
      formEl.reset();
      return;
    }
    payload.delete('website_alt');

    setStatus('submitting');
    setFormError('');

    const body = new URLSearchParams();
    payload.forEach((value, key) => {
      body.append(key, String(value));
    });

    try {
      const response = await fetch(FORM_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: body.toString(),
      });

      const responseText = await response.text();
      let parsed: { code?: string; message?: string; meta?: { message?: string; detail?: string } } | null =
        null;
      try {
        parsed = JSON.parse(responseText);
      } catch {
        parsed = null;
      }

      const serverMsg =
        parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '';
      const isSpam = /spam/i.test(serverMsg) || /spam/i.test(responseText);
      const okCode = parsed?.code === 'OK';

      if (!response.ok || !okCode || isSpam) {
        setStatus('error');
        setFormError(serverMsg || '订阅提交失败，请稍后再试。');
        return;
      }

      setStatus('success');
      setFormError('');
      formEl.reset();
    } catch {
      setStatus('error');
      setFormError('网络异常，订阅未提交成功，请稍后再试。');
    }
  };

  return (
    <form data-readdy-form id="xigua-newsletter-form" onSubmit={handleSubmit} className="w-full">
      <div className="flex flex-col gap-3 sm:flex-row">
        <input
          type="email"
          name="email"
          required
          placeholder="填入邮箱，新瓜第一时间提醒你"
          className="h-11 w-full rounded-md border border-accent-700/60 bg-accent-900/40 px-4 text-sm text-background-50 placeholder:text-background-100/60 focus:border-accent-300 focus:outline-none focus:ring-2 focus:ring-accent-500/50"
        />
        <button
          type="submit"
          disabled={status === 'submitting'}
          className="h-11 whitespace-nowrap rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-400 disabled:opacity-60"
        >
          {status === 'submitting' ? '提交中…' : '订阅瓜讯'}
        </button>
      </div>

      <input
        type="text"
        name="website_alt"
        tabIndex={-1}
        autoComplete="off"
        aria-hidden="true"
        readOnly
        className="form-guard-alt"
      />

      <div aria-live="polite" className="mt-2 min-h-5 text-xs">
        {status === 'success' && (
          <span className="text-accent-200">订阅成功，热闹的瓜我们不会让你错过。</span>
        )}
        {status === 'error' && <span className="text-primary-300">{formError}</span>}
      </div>
    </form>
  );
}